import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useLayoutEffect } from "react";
import { AzureAD, AuthenticationState } from 'react-aad-msal'; // JSS

import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { SitecoreLink } from '../link/Link';
import { Row, Col } from "react-bootstrap"; // Design System

import Heading from '../heading/Heading';
import { RadioButton } from "../forms/elements/Radio";
import MediaQuery from "react-responsive";
import ImageLoader from '../images/ImageLoader';
import { SwatchDisplay } from "./SwatchDisplay";
import * as UTIL from "../../util"; //ga tracker

import gaTracker from '../../util/ga-analytics/gaTracker';
import { ecommAdd, ecommClick } from "../../util";
import { uniq } from "lodash";
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
export default (function (props) {
  var _link$value;

  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      addToOrder = props.addToOrder,
      noLocation = props.noLocation,
      _props$saveDefault = props.saveDefault,
      saveDefault = _props$saveDefault === void 0 ? function () {
    return "";
  } : _props$saveDefault,
      _props$handleFavorite = props.handleFavorite,
      handleFavorite = _props$handleFavorite === void 0 ? function () {
    return "";
  } : _props$handleFavorite,
      isRetail = props.isRetail,
      isEditing = props.isEditing;
  var _model$image = model.image,
      image = _model$image === void 0 ? {} : _model$image,
      _model$title = model.title,
      title = _model$title === void 0 ? {} : _model$title,
      _model$text = model.text,
      text = _model$text === void 0 ? {} : _model$text,
      _model$price = model.price,
      price = _model$price === void 0 ? {} : _model$price,
      _model$calorie = model.calorie,
      calorie = _model$calorie === void 0 ? {} : _model$calorie,
      _model$likes = model.likes,
      likes = _model$likes === void 0 ? {} : _model$likes,
      _model$available = model.available,
      available = _model$available === void 0 ? {} : _model$available,
      _model$link = model.link,
      link = _model$link === void 0 ? {} : _model$link,
      _model$link2 = model.link2,
      link2 = _model$link2 === void 0 ? {} : _model$link2,
      _model$link3 = model.link3,
      link3 = _model$link3 === void 0 ? {} : _model$link3,
      tags = model.tags,
      _model$lighterFare = model.lighterFare,
      lighterFare = _model$lighterFare === void 0 ? null : _model$lighterFare,
      servingSize = model.servingSize,
      almostGoneBanner = model.almostGoneBanner,
      exclusiveBanner = model.exclusiveBanner,
      exclusiveText = model.exclusiveText,
      sku = model.sku,
      _model$isFavorite = model.isFavorite,
      isFavorite = _model$isFavorite === void 0 ? false : _model$isFavorite,
      productId = model.productId,
      _model$swatches = model.swatches,
      swatches = _model$swatches === void 0 ? [] : _model$swatches,
      variantsExist = model.variantsExist,
      noButton = model.noButton,
      optionsExist = model.optionsExist,
      isWishlistRetail = model.isRetail;

  var _useState = useState(isFavorite),
      _useState2 = _slicedToArray(_useState, 2),
      favorite = _useState2[0],
      setFavorite = _useState2[1];

  var wishlistHandler = function wishlistHandler() {
    var newFavorite = !favorite;
    setFavorite(newFavorite);
    handleFavorite(sku || productId, newFavorite);
    favoriteClick();
  };

  var favoriteClick = function favoriteClick() {
    var data = {
      gtm: {
        uniqueEventId: 61,
        elementTarget: title.value,
        elementId: "favorite-".concat(sku || productId),
        productName: title.value || title
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  var customizeClick = function customizeClick() {
    var _link3$value, _model$fullElement;

    var data = {
      gtm: {
        uniqueEventId: 72,
        elementTarget: title.value,
        elementId: "customize-".concat(sku || productId)
      },
      event: 'gtm.click'
    };
    gaTracker(data);
    ecommClick({
      name: title.value || title,
      id: sku || productId,
      price: price.value || price,
      detailLink: ((_link3$value = link3.value) === null || _link3$value === void 0 ? void 0 : _link3$value.href) || '',
      catalog: (model === null || model === void 0 ? void 0 : (_model$fullElement = model.fullElement) === null || _model$fullElement === void 0 ? void 0 : _model$fullElement.CatalogName) || ''
    });
  };

  var featureClick = function featureClick(event) {
    var _link3$value2, _model$fullElement2;

    var data = {
      gtm: {
        uniqueEventId: 76,
        elementTarget: title.value,
        elementId: "feature-".concat(sku || productId)
      },
      event: 'gtm.click'
    };
    gaTracker(data);
    ecommClick({
      name: title.value || title,
      id: sku || productId,
      price: price.value || price,
      detailLink: ((_link3$value2 = link3.value) === null || _link3$value2 === void 0 ? void 0 : _link3$value2.href) || '',
      catalog: (model === null || model === void 0 ? void 0 : (_model$fullElement2 = model.fullElement) === null || _model$fullElement2 === void 0 ? void 0 : _model$fullElement2.CatalogName) || ''
    });
  };

  return /*#__PURE__*/React.createElement(SitecoreLink, {
    field: {
      value: {
        href: noLocation ? "#" : (_link$value = link.value) === null || _link$value === void 0 ? void 0 : _link$value.href
      }
    },
    className: "cb-card__category-link"
  }, /*#__PURE__*/React.createElement("div", {
    className: "\n          cb-card\n          cb-card__food\n          cb-card__category\n      "
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-card__image-container"
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    isEditing: isEditing,
    media: image,
    className: "cb-card__image"
  })), /*#__PURE__*/React.createElement("div", {
    className: "cb-card__copy-container cb-card__copy-container--small ".concat(noLocation ? "no-location" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-card__food-copy"
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-card__link d-flex justify-content-between",
    id: "feature-".concat(sku || productId)
  }, /*#__PURE__*/React.createElement(Heading, {
    level: "2",
    field: title,
    className: "cb-card__title"
  })), text && /*#__PURE__*/React.createElement(RichText, {
    tag: "p",
    field: text,
    className: "cb-type-body-sm"
  })))));
});